export interface GeneralPermissions {
  background: {
    create: PERMISSION;
    downloadTemplate: PERMISSION;
  };
  customMeteo: {
    create: PERMISSION;
    downloadTemplate: PERMISSION;
  };
  cases: {
    createNormal: PERMISSION;
    createPredefined: PERMISSION;
    startOspm: PERMISSION;
  };
  scenario: {
    residential: PERMISSION;
  };
  users: {
    userAdmin: PERMISSION;
  };
  searchBar: {
    search: PERMISSION;
  };
}

export enum PERMISSION {
  ENABLED = "ENABLED",
  DISABLED = "DISABLED",
  HIDDEN = "HIDDEN",
}
